import { render, staticRenderFns } from "./g-assistant-bubble.vue?vue&type=template&id=721903d2&scoped=true&"
import script from "./g-assistant-bubble.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-assistant-bubble.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-assistant-bubble.vue?vue&type=style&index=0&id=721903d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721903d2",
  null
  
)

export default component.exports